exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.try-outfit[data-v-735808c9] {\n  bottom: 80px;\n  color: #fff;\n  left: 0;\n  position: absolute;\n  right: 0;\n  text-align: center;\n}\n.title[data-v-735808c9] {\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 600;\n  max-width: 260px;\n  margin: 0 auto 14px;\n}\n.subtext[data-v-735808c9] {\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.6px;\n  max-width: 290px;\n  margin: 0 auto;\n}", ""]);

// exports
